/* Liquid Metal Shader — circle effect around team photos */
(function () {
  'use strict';

  /* ─── GLSL snippets ─── */
  var declarePI = '\n#define TWO_PI 6.28318530718\n#define PI 3.14159265358979323846\n';
  var rotation2 = '\nvec2 rotate(vec2 uv, float th) {\n  return mat2(cos(th), sin(th), -sin(th), cos(th)) * uv;\n}\n';
  var simplexNoise = [
    'vec3 permute(vec3 x) { return mod(((x * 34.0) + 1.0) * x, 289.0); }',
    'float snoise(vec2 v) {',
    '  const vec4 C = vec4(0.211324865405187, 0.366025403784439,',
    '    -0.577350269189626, 0.024390243902439);',
    '  vec2 i = floor(v + dot(v, C.yy));',
    '  vec2 x0 = v - i + dot(i, C.xx);',
    '  vec2 i1;',
    '  i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);',
    '  vec4 x12 = x0.xyxy + C.xxzz;',
    '  x12.xy -= i1;',
    '  i = mod(i, 289.0);',
    '  vec3 p = permute(permute(i.y + vec3(0.0, i1.y, 1.0))',
    '    + i.x + vec3(0.0, i1.x, 1.0));',
    '  vec3 m = max(0.5 - vec3(dot(x0, x0), dot(x12.xy, x12.xy),',
    '      dot(x12.zw, x12.zw)), 0.0);',
    '  m = m * m;',
    '  m = m * m;',
    '  vec3 x = 2.0 * fract(p * C.www) - 1.0;',
    '  vec3 h = abs(x) - 0.5;',
    '  vec3 ox = floor(x + 0.5);',
    '  vec3 a0 = x - ox;',
    '  m *= 1.79284291400159 - 0.85373472095314 * (a0 * a0 + h * h);',
    '  vec3 g;',
    '  g.x = a0.x * x0.x + h.x * x0.y;',
    '  g.yz = a0.yz * x12.xz + h.yz * x12.yw;',
    '  return 130.0 * dot(m, g);',
    '}'
  ].join('\n');
  var colorBandingFix = '  color += 1. / 256. * (fract(sin(dot(.014 * gl_FragCoord.xy, vec2(12.9898, 78.233))) * 43758.5453123) - .5);';

  /* ─── Vertex shader ─── */
  var vertexShaderSource = '#version 300 es\nprecision mediump float;\n\nlayout(location = 0) in vec4 a_position;\n\nuniform vec2 u_resolution;\nuniform float u_pixelRatio;\nuniform float u_imageAspectRatio;\nuniform float u_originX;\nuniform float u_originY;\nuniform float u_worldWidth;\nuniform float u_worldHeight;\nuniform float u_fit;\nuniform float u_scale;\nuniform float u_rotation;\nuniform float u_offsetX;\nuniform float u_offsetY;\n\nout vec2 v_objectUV;\nout vec2 v_objectBoxSize;\nout vec2 v_responsiveUV;\nout vec2 v_responsiveBoxGivenSize;\nout vec2 v_patternUV;\nout vec2 v_patternBoxSize;\nout vec2 v_imageUV;\n\nvec3 getBoxSize(float boxRatio, vec2 givenBoxSize) {\n  vec2 box = vec2(0.);\n  box.x = boxRatio * min(givenBoxSize.x / boxRatio, givenBoxSize.y);\n  float noFitBoxWidth = box.x;\n  if (u_fit == 1.) {\n    box.x = boxRatio * min(u_resolution.x / boxRatio, u_resolution.y);\n  } else if (u_fit == 2.) {\n    box.x = boxRatio * max(u_resolution.x / boxRatio, u_resolution.y);\n  }\n  box.y = box.x / boxRatio;\n  return vec3(box, noFitBoxWidth);\n}\n\nvoid main() {\n  gl_Position = a_position;\n  vec2 uv = gl_Position.xy * .5;\n  vec2 boxOrigin = vec2(.5 - u_originX, u_originY - .5);\n  vec2 givenBoxSize = vec2(u_worldWidth, u_worldHeight);\n  givenBoxSize = max(givenBoxSize, vec2(1.)) * u_pixelRatio;\n  float r = u_rotation * 3.14159265358979323846 / 180.;\n  mat2 graphicRotation = mat2(cos(r), sin(r), -sin(r), cos(r));\n  vec2 graphicOffset = vec2(-u_offsetX, u_offsetY);\n\n  float fixedRatio = 1.;\n  vec2 fixedRatioBoxGivenSize = vec2(\n  (u_worldWidth == 0.) ? u_resolution.x : givenBoxSize.x,\n  (u_worldHeight == 0.) ? u_resolution.y : givenBoxSize.y\n  );\n  v_objectBoxSize = getBoxSize(fixedRatio, fixedRatioBoxGivenSize).xy;\n  vec2 objectWorldScale = u_resolution.xy / v_objectBoxSize;\n  v_objectUV = uv;\n  v_objectUV *= objectWorldScale;\n  v_objectUV += boxOrigin * (objectWorldScale - 1.);\n  v_objectUV += graphicOffset;\n  v_objectUV /= u_scale;\n  v_objectUV = graphicRotation * v_objectUV;\n\n  v_responsiveBoxGivenSize = vec2(\n  (u_worldWidth == 0.) ? u_resolution.x : givenBoxSize.x,\n  (u_worldHeight == 0.) ? u_resolution.y : givenBoxSize.y\n  );\n  float responsiveRatio = v_responsiveBoxGivenSize.x / v_responsiveBoxGivenSize.y;\n  vec2 responsiveBoxSize = getBoxSize(responsiveRatio, v_responsiveBoxGivenSize).xy;\n  vec2 responsiveBoxScale = u_resolution.xy / responsiveBoxSize;\n  v_responsiveUV = uv;\n  v_responsiveUV *= responsiveBoxScale;\n  v_responsiveUV += boxOrigin * (responsiveBoxScale - 1.);\n  v_responsiveUV += graphicOffset;\n  v_responsiveUV /= u_scale;\n  v_responsiveUV.x *= responsiveRatio;\n  v_responsiveUV = graphicRotation * v_responsiveUV;\n  v_responsiveUV.x /= responsiveRatio;\n\n  float patternBoxRatio = givenBoxSize.x / givenBoxSize.y;\n  vec2 patternBoxGivenSize = vec2(\n  (u_worldWidth == 0.) ? u_resolution.x : givenBoxSize.x,\n  (u_worldHeight == 0.) ? u_resolution.y : givenBoxSize.y\n  );\n  patternBoxRatio = patternBoxGivenSize.x / patternBoxGivenSize.y;\n  vec3 boxSizeData = getBoxSize(patternBoxRatio, patternBoxGivenSize);\n  v_patternBoxSize = boxSizeData.xy;\n  float patternBoxNoFitBoxWidth = boxSizeData.z;\n  vec2 patternBoxScale = u_resolution.xy / v_patternBoxSize;\n  v_patternUV = uv;\n  v_patternUV += graphicOffset / patternBoxScale;\n  v_patternUV += boxOrigin;\n  v_patternUV -= boxOrigin / patternBoxScale;\n  v_patternUV *= u_resolution.xy;\n  v_patternUV /= u_pixelRatio;\n  if (u_fit > 0.) {\n    v_patternUV *= (patternBoxNoFitBoxWidth / v_patternBoxSize.x);\n  }\n  v_patternUV /= u_scale;\n  v_patternUV = graphicRotation * v_patternUV;\n  v_patternUV += boxOrigin / patternBoxScale;\n  v_patternUV -= boxOrigin;\n  v_patternUV *= .01;\n\n  vec2 imageBoxSize;\n  if (u_fit == 1.) {\n    imageBoxSize.x = min(u_resolution.x / u_imageAspectRatio, u_resolution.y) * u_imageAspectRatio;\n  } else if (u_fit == 2.) {\n    imageBoxSize.x = max(u_resolution.x / u_imageAspectRatio, u_resolution.y) * u_imageAspectRatio;\n  } else {\n    imageBoxSize.x = min(10.0, 10.0 / u_imageAspectRatio * u_imageAspectRatio);\n  }\n  imageBoxSize.y = imageBoxSize.x / u_imageAspectRatio;\n  vec2 imageBoxScale = u_resolution.xy / imageBoxSize;\n  v_imageUV = uv;\n  v_imageUV *= imageBoxScale;\n  v_imageUV += boxOrigin * (imageBoxScale - 1.);\n  v_imageUV += graphicOffset;\n  v_imageUV /= u_scale;\n  v_imageUV.x *= u_imageAspectRatio;\n  v_imageUV = graphicRotation * v_imageUV;\n  v_imageUV.x /= u_imageAspectRatio;\n  v_imageUV += .5;\n  v_imageUV.y = 1. - v_imageUV.y;\n}';

  /* ─── Fragment shader (liquid metal, circle shape) ─── */
  var fragmentShader = '#version 300 es\nprecision mediump float;\n\nuniform sampler2D u_image;\nuniform float u_imageAspectRatio;\n\nuniform vec2 u_resolution;\nuniform float u_time;\n\nuniform vec4 u_colorBack;\nuniform vec4 u_colorTint;\n\nuniform float u_softness;\nuniform float u_repetition;\nuniform float u_shiftRed;\nuniform float u_shiftBlue;\nuniform float u_distortion;\nuniform float u_contour;\nuniform float u_angle;\n\nuniform float u_shape;\nuniform bool u_isImage;\n\nin vec2 v_objectUV;\nin vec2 v_responsiveUV;\nin vec2 v_responsiveBoxGivenSize;\nin vec2 v_imageUV;\n\nout vec4 fragColor;\n\n' + declarePI + '\n' + rotation2 + '\n' + simplexNoise + '\n\nfloat getColorChanges(float c1, float c2, float stripe_p, vec3 w, float blur, float bump, float tint) {\n  float ch = mix(c2, c1, smoothstep(.0, 2. * blur, stripe_p));\n  float border = w[0];\n  ch = mix(ch, c2, smoothstep(border, border + 2. * blur, stripe_p));\n  bump = smoothstep(.2, .8, bump);\n  border = w[0] + .4 * (1. - bump) * w[1];\n  ch = mix(ch, c1, smoothstep(border, border + 2. * blur, stripe_p));\n  border = w[0] + .5 * (1. - bump) * w[1];\n  ch = mix(ch, c2, smoothstep(border, border + 2. * blur, stripe_p));\n  border = w[0] + w[1];\n  ch = mix(ch, c1, smoothstep(border, border + 2. * blur, stripe_p));\n  float gradient_t = (stripe_p - w[0] - w[1]) / w[2];\n  float gradient = mix(c1, c2, smoothstep(0., 1., gradient_t));\n  ch = mix(ch, gradient, smoothstep(border, border + .5 * blur, stripe_p));\n  ch = mix(ch, 1. - min(1., (1. - ch) / max(tint, 0.0001)), u_colorTint.a);\n  return ch;\n}\n\nfloat lst(float edge0, float edge1, float x) {\n  return clamp((x - edge0) / (edge1 - edge0), 0.0, 1.0);\n}\n\nvoid main() {\n  const float firstFrameOffset = 2.8;\n  float t = .3 * (u_time + firstFrameOffset);\n\n  vec2 uv = v_imageUV;\n  vec2 dudx = dFdx(v_imageUV);\n  vec2 dudy = dFdy(v_imageUV);\n\n  uv = v_objectUV + .5;\n  uv.y = 1. - uv.y;\n\n  float cycleWidth = u_repetition;\n  float edge = 0.;\n  float contOffset = 1.;\n\n  vec2 rotatedUV = uv - vec2(.5);\n  float angle = (-u_angle + 70.) * PI / 180.;\n  float cosA = cos(angle);\n  float sinA = sin(angle);\n  rotatedUV = vec2(\n    rotatedUV.x * cosA - rotatedUV.y * sinA,\n    rotatedUV.x * sinA + rotatedUV.y * cosA\n  ) + vec2(.5);\n\n  // circle shape\n  vec2 shapeUV = uv - .5;\n  shapeUV *= .67;\n  edge = pow(clamp(3. * length(shapeUV), 0., 1.), 18.);\n\n  edge = mix(smoothstep(.9 - 2. * fwidth(edge), .9, edge), edge, smoothstep(0.0, 0.4, u_contour));\n\n  float opacity = 1. - smoothstep(.9 - 2. * fwidth(edge), .9, edge);\n  edge = 1.2 * edge;\n\n  float diagBLtoTR = rotatedUV.x - rotatedUV.y;\n  float diagTLtoBR = rotatedUV.x + rotatedUV.y;\n\n  vec3 color = vec3(0.);\n  vec3 color1 = vec3(.98, 0.98, 1.);\n  vec3 color2 = vec3(.1, .1, .1 + .1 * smoothstep(.7, 1.3, diagTLtoBR));\n\n  vec2 grad_uv = uv - .5;\n  float dist = length(grad_uv + vec2(0., .2 * diagBLtoTR));\n  grad_uv = rotate(grad_uv, (.25 - .2 * diagBLtoTR) * PI);\n  float direction = grad_uv.x;\n  float bump = pow(1.8 * dist, 1.2);\n  bump = 1. - bump;\n  bump *= pow(uv.y, .3);\n\n  float thin_strip_1_ratio = .12 / cycleWidth * (1. - .4 * bump);\n  float thin_strip_2_ratio = .07 / cycleWidth * (1. + .4 * bump);\n  float wide_strip_ratio = (1. - thin_strip_1_ratio - thin_strip_2_ratio);\n  float thin_strip_1_width = cycleWidth * thin_strip_1_ratio;\n  float thin_strip_2_width = cycleWidth * thin_strip_2_ratio;\n\n  float noise = snoise(uv - t);\n  edge += (1. - edge) * u_distortion * noise;\n\n  direction += diagBLtoTR;\n  float contour = 0.;\n  direction -= 2. * noise * diagBLtoTR * (smoothstep(0., 1., edge) * (1.0 - smoothstep(0., 1., edge)));\n  direction *= mix(1., 1. - edge, smoothstep(.5, 1., u_contour));\n  direction -= 1.7 * edge * smoothstep(.5, 1., u_contour);\n  direction += .2 * pow(u_contour, 4.) * (1.0 - smoothstep(0., 1., edge));\n\n  bump *= clamp(pow(uv.y, .1), .3, 1.);\n  direction *= (.1 + (1.1 - edge) * bump);\n  direction *= (.4 + .6 * (1.0 - smoothstep(.5, 1., edge)));\n  direction += .18 * (smoothstep(.1, .2, uv.y) * (1.0 - smoothstep(.2, .4, uv.y)));\n  direction += .03 * (smoothstep(.1, .2, 1. - uv.y) * (1.0 - smoothstep(.2, .4, 1. - uv.y)));\n  direction *= (.5 + .5 * pow(uv.y, 2.));\n  direction *= cycleWidth;\n  direction -= t;\n\n  float colorDispersion = (1. - bump);\n  colorDispersion = clamp(colorDispersion, 0., 1.);\n  float dispersionRed = colorDispersion;\n  dispersionRed += .03 * bump * noise;\n  dispersionRed += 5. * (smoothstep(-.1, .2, uv.y) * (1.0 - smoothstep(.1, .5, uv.y))) * (smoothstep(.4, .6, bump) * (1.0 - smoothstep(.4, 1., bump)));\n  dispersionRed -= diagBLtoTR;\n  float dispersionBlue = colorDispersion;\n  dispersionBlue *= 1.3;\n  dispersionBlue += (smoothstep(0., .4, uv.y) * (1.0 - smoothstep(.1, .8, uv.y))) * (smoothstep(.4, .6, bump) * (1.0 - smoothstep(.4, .8, bump)));\n  dispersionBlue -= .2 * edge;\n  dispersionRed *= (u_shiftRed / 20.);\n  dispersionBlue *= (u_shiftBlue / 20.);\n\n  float blur = u_softness / 15. + .3 * contour;\n\n  vec3 w = vec3(thin_strip_1_width, thin_strip_2_width, wide_strip_ratio);\n  w[1] -= .02 * smoothstep(.0, 1., edge + bump);\n  float stripe_r = fract(direction + dispersionRed);\n  float r = getColorChanges(color1.r, color2.r, stripe_r, w, blur + fwidth(stripe_r), bump, u_colorTint.r);\n  float stripe_g = fract(direction);\n  float g = getColorChanges(color1.g, color2.g, stripe_g, w, blur + fwidth(stripe_g), bump, u_colorTint.g);\n  float stripe_b = fract(direction - dispersionBlue);\n  float b = getColorChanges(color1.b, color2.b, stripe_b, w, blur + fwidth(stripe_b), bump, u_colorTint.b);\n\n  color = vec3(r, g, b);\n  color *= opacity;\n\n  vec3 bgColor = u_colorBack.rgb * u_colorBack.a;\n  color = color + bgColor * (1. - opacity);\n  opacity = opacity + u_colorBack.a * (1. - opacity);\n\n' + colorBandingFix + '\n\n  fragColor = vec4(color, opacity);\n}\n';

  /* ─── Helpers ─── */
  function createShader(gl, type, source) {
    var shader = gl.createShader(type);
    if (!shader) return null;
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      console.error('Shader compile error: ' + gl.getShaderInfoLog(shader));
      gl.deleteShader(shader);
      return null;
    }
    return shader;
  }

  function createProgram(gl, vsSrc, fsSrc) {
    var fmt = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT);
    var prec = fmt ? fmt.precision : null;
    if (prec && prec < 23) {
      vsSrc = vsSrc.replace(/precision\s+(lowp|mediump)\s+float;/g, 'precision highp float;');
      fsSrc = fsSrc.replace(/precision\s+(lowp|mediump)\s+float/g, 'precision highp float').replace(/\b(uniform|varying|attribute)\s+(lowp|mediump)\s+(\w+)/g, '$1 highp $3');
    }
    var vs = createShader(gl, gl.VERTEX_SHADER, vsSrc);
    var fs = createShader(gl, gl.FRAGMENT_SHADER, fsSrc);
    if (!vs || !fs) return null;
    var prog = gl.createProgram();
    if (!prog) return null;
    gl.attachShader(prog, vs);
    gl.attachShader(prog, fs);
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) {
      console.error('Program link error: ' + gl.getProgramInfoLog(prog));
      gl.deleteProgram(prog);
      gl.deleteShader(vs);
      gl.deleteShader(fs);
      return null;
    }
    gl.detachShader(prog, vs);
    gl.detachShader(prog, fs);
    gl.deleteShader(vs);
    gl.deleteShader(fs);
    return prog;
  }

  /* ─── LiquidMetalRing — lightweight mount for one element ─── */
  function LiquidMetalRing(parentEl, uniforms, speed) {
    this.parent = parentEl;
    this.speed = speed || 0.6;
    this.currentSpeed = this.speed;
    this.frame = 0;
    this.lastTime = 0;
    this.rafId = null;
    this.disposed = false;

    // Canvas — rendered as ring behind the photo
    var canvas = document.createElement('canvas');
    canvas.className = 'lm-ring-canvas';
    var ringPad = 6;
    var ringSize = this.parent.offsetWidth + (ringPad * 2);
    canvas.style.cssText = 'display:block;position:absolute;pointer-events:none;z-index:0;border-radius:50%;top:-' + ringPad + 'px;left:-' + ringPad + 'px;width:' + ringSize + 'px;height:' + ringSize + 'px;';
    this.canvas = canvas;
    this.parent.prepend(canvas);

    // GL
    var gl = canvas.getContext('webgl2', { alpha: true, premultipliedAlpha: true });
    if (!gl) { console.warn('WebGL2 not supported'); return; }
    this.gl = gl;
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

    this.program = createProgram(gl, vertexShaderSource, fragmentShader);
    if (!this.program) return;

    // Quad
    var posLoc = gl.getAttribLocation(this.program, 'a_position');
    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(posLoc);
    gl.vertexAttribPointer(posLoc, 2, gl.FLOAT, false, 0, 0);

    // Uniforms
    this.uLocs = {};
    var names = ['u_time','u_pixelRatio','u_resolution','u_colorBack','u_colorTint',
      'u_softness','u_repetition','u_shiftRed','u_shiftBlue','u_distortion',
      'u_contour','u_angle','u_shape','u_isImage','u_imageAspectRatio',
      'u_originX','u_originY','u_worldWidth','u_worldHeight','u_fit','u_scale',
      'u_rotation','u_offsetX','u_offsetY'];
    gl.useProgram(this.program);
    for (var i = 0; i < names.length; i++) {
      this.uLocs[names[i]] = gl.getUniformLocation(this.program, names[i]);
    }

    // Set static uniforms
    gl.uniform1f(this.uLocs.u_shape, uniforms.u_shape);
    gl.uniform1i(this.uLocs.u_isImage, 0);
    gl.uniform1f(this.uLocs.u_softness, uniforms.u_softness);
    gl.uniform1f(this.uLocs.u_repetition, uniforms.u_repetition);
    gl.uniform1f(this.uLocs.u_shiftRed, uniforms.u_shiftRed);
    gl.uniform1f(this.uLocs.u_shiftBlue, uniforms.u_shiftBlue);
    gl.uniform1f(this.uLocs.u_distortion, uniforms.u_distortion);
    gl.uniform1f(this.uLocs.u_contour, uniforms.u_contour);
    gl.uniform1f(this.uLocs.u_angle, uniforms.u_angle);
    gl.uniform4fv(this.uLocs.u_colorBack, uniforms.u_colorBack);
    gl.uniform4fv(this.uLocs.u_colorTint, uniforms.u_colorTint);
    gl.uniform1f(this.uLocs.u_imageAspectRatio, 1.0);
    gl.uniform1f(this.uLocs.u_originX, 0.5);
    gl.uniform1f(this.uLocs.u_originY, 0.5);
    gl.uniform1f(this.uLocs.u_worldWidth, 0);
    gl.uniform1f(this.uLocs.u_worldHeight, 0);
    gl.uniform1f(this.uLocs.u_fit, 0);
    gl.uniform1f(this.uLocs.u_scale, uniforms.u_scale || 1);
    gl.uniform1f(this.uLocs.u_rotation, 0);
    gl.uniform1f(this.uLocs.u_offsetX, uniforms.u_offsetX || 0);
    gl.uniform1f(this.uLocs.u_offsetY, uniforms.u_offsetY || 0);

    // Resize observer
    var self = this;
    this.resizeObs = new ResizeObserver(function () { self.resize(); });
    this.resizeObs.observe(this.parent);
    this.resize();

    // Visibility
    this._visHandler = function () {
      self.currentSpeed = document.hidden ? 0 : self.speed;
      if (!document.hidden && self.rafId === null) { self.lastTime = performance.now(); self.loop(self.lastTime); }
      if (document.hidden && self.rafId !== null) { cancelAnimationFrame(self.rafId); self.rafId = null; }
    };
    document.addEventListener('visibilitychange', this._visHandler);

    // Start
    this.lastTime = performance.now();
    this.loop(this.lastTime);
  }

  LiquidMetalRing.prototype.resize = function () {
    var dpr = Math.max(window.devicePixelRatio, 2);
    // Canvas is 12px larger than parent (6px ring on each side), always square
    var size = this.parent.offsetWidth + 12;
    this.canvas.style.width = size + 'px';
    this.canvas.style.height = size + 'px';
    var px = Math.round(size * dpr);
    if (this.canvas.width !== px || this.canvas.height !== px) {
      this.canvas.width = px;
      this.canvas.height = px;
      this.gl.viewport(0, 0, px, px);
      this.gl.useProgram(this.program);
      this.gl.uniform2f(this.uLocs.u_resolution, px, px);
      this.gl.uniform1f(this.uLocs.u_pixelRatio, dpr);
    }
  };

  LiquidMetalRing.prototype.loop = function (now) {
    if (this.disposed) return;
    var dt = now - this.lastTime;
    this.lastTime = now;
    if (this.currentSpeed !== 0) this.frame += dt * this.currentSpeed;
    var gl = this.gl;
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.useProgram(this.program);
    gl.uniform1f(this.uLocs.u_time, this.frame * 0.001);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
    var self = this;
    if (this.currentSpeed !== 0) {
      this.rafId = requestAnimationFrame(function (t) { self.loop(t); });
    } else {
      this.rafId = null;
    }
  };

  LiquidMetalRing.prototype.dispose = function () {
    this.disposed = true;
    if (this.rafId !== null) cancelAnimationFrame(this.rafId);
    if (this.resizeObs) this.resizeObs.disconnect();
    document.removeEventListener('visibilitychange', this._visHandler);
    if (this.gl && this.program) this.gl.deleteProgram(this.program);
    this.canvas.remove();
  };

  /* ─── Init ─── */
  function initGroup(selector, customUniforms, wrapSize) {
    var elements = document.querySelectorAll(selector);
    if (!elements.length) return [];

    var testCanvas = document.createElement('canvas');
    var testGl = testCanvas.getContext('webgl2');
    if (!testGl) return [];

    var defaults = {
      u_repetition: 4,
      u_softness: 0.5,
      u_shiftRed: 0.3,
      u_shiftBlue: 0.3,
      u_distortion: 0,
      u_contour: 0,
      u_angle: 45,
      u_scale: 1,
      u_shape: 1,
      u_offsetX: 0,
      u_offsetY: 0,
      u_colorBack: [0, 0, 0, 0],
      u_colorTint: [0.58, 0.63, 0.72, 0.15]
    };
    var uniforms = {};
    for (var k in defaults) uniforms[k] = defaults[k];
    if (customUniforms) { for (var k2 in customUniforms) uniforms[k2] = customUniforms[k2]; }

    var mounts = [];
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var mount = entry.target._lmRing;
        if (!mount) return;
        if (entry.isIntersecting) {
          mount.currentSpeed = mount.speed;
          if (mount.rafId === null && !document.hidden) {
            mount.lastTime = performance.now();
            mount.loop(mount.lastTime);
          }
        } else {
          mount.currentSpeed = 0;
          if (mount.rafId !== null) {
            cancelAnimationFrame(mount.rafId);
            mount.rafId = null;
          }
        }
      });
    }, { rootMargin: '100px' });

    elements.forEach(function (el) {
      if (el.closest('.lm-ring-wrap')) return; // already wrapped
      var wrapper = document.createElement('div');
      wrapper.className = 'lm-ring-wrap';
      if (wrapSize) {
        wrapper.style.width = wrapSize + 'px';
        wrapper.style.height = wrapSize + 'px';
      }
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);

      var ring = new LiquidMetalRing(wrapper, uniforms, 0.6);
      wrapper._lmRing = ring;
      mounts.push(ring);
      observer.observe(wrapper);
    });
    return mounts;
  }

  /* Expose globally so pages can call with custom config */
  window.initLiquidMetal = initGroup;

  function init() {
    // About Us page — team photos
    initGroup('.about-team__photo', {
      u_colorTint: [0.58, 0.63, 0.72, 0.15]
    });

    // Caulk Club page — (liquid metal available via .lm-target class)

    // Any generic lm-target elements
    initGroup('.lm-target', {
      u_colorTint: [0.58, 0.63, 0.72, 0.15]
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
